import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from 'Theme';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        backgroundColor: Theme.primaryBackgroundColor,
        paddingStart: 80,
        paddingEnd: 80
    },
    heading: {
        fontFamily: Theme.regularFont,
        fontSize: 25,
        color: Theme.primaryTextColor,
        textAlign: 'center'
    },
    fistHeading: {
        marginVertical: 15
    },
    secondHeading: {
        marginTop: 25,
        marginBottom: 10
    },
    infoText: {
        color: Theme.secondaryTextColor,
        marginVertical: 10
    },
    listRow: {
        flexDirection: 'row',
        marginBottom: 10
    },
    listItem: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.primaryFontSize,
        color: Theme.primaryTextColor
    },
    listItemDot: {
        flex: 1,
        paddingEnd: 20,
        height: 20
    }
});

class RegisterPage extends React.Component {
    componentWillUnmount() {
        // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
        // eslint-disable-next-line react/prop-types
        const { navigation, route } = this.props;
        const fromLogin = route.params?.fromLogin || false;
        if (fromLogin) navigation.navigate('Login');
    }

    render() {
        return (
            <View style={styles.container}>
                <Text style={styles.heading}>Register</Text>
            </View>
        );
    }
}

export default RegisterPage;
